import {InboxService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _InboxService = new InboxService({client});
export {_InboxService as InboxService};
